module.exports = __webpack_public_path__ + "static/media/objetos-layout-02.8f0b5ce8.jpg";